<template>
  <div class="card-container">
    <Row>
            <Col span="8" class="box-header">
              <h2>Выручка</h2>
            </Col>
      <Col span="24" class="box-header-filter">
        <Menu
          mode="horizontal"
          :active-name="defaultFilter"
          @on-select="selectFilter"
        >
          <MenuItem name="year" class="menu-item">
            Год
          </MenuItem>
          <MenuItem name="month" class="menu-item">
            Месяц
          </MenuItem>
          <MenuItem name="week" class="menu-item">
            Неделя
          </MenuItem>
          <MenuItem name="day" class="menu-item">
            День
          </MenuItem>
        </Menu>
      </Col>
    </Row>

    <revenueBarChart :data="data" style="margin-top: 20px"></revenueBarChart>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>
<script>
    import revenueBarChart from "./revenueBarChart";
    import { base_url } from "../../http";
    import { formatNumber } from "../../base/base_func.js";
    export default {
        name: "revenueBar",
        components: {
            revenueBarChart
        },
        data() {
            return {
                loading: true,
                defaultFilter: "month",
                data: [],
            };
        },
        methods: {
            selectFilter: function(period) {
                this.fetchPayments(period);
            },
            fetchPayments: function(period) {
                this.loading = true;
                let url = `${base_url}/charts/revenue_bar/`;
                this.$http
                    .get(url, {
                        params: { period: period }
                    })
                    .then(result => {
                        this.data = result.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            formatNumber(val) {
                return formatNumber(val);
            }
        },
        mounted: function() {
            this.fetchPayments(this.defaultFilter);
        }
    };
</script>

<style scoped>
  .card-container {
    padding: 10px;
    position: relative;
  }
  .box-header,
  .box-count-label {
    text-align: left;
    font-weight: bold;
    font-size: 20px;
    padding: 10px 20px;

  }



  .ivu-menu-horizontal {
    height: auto;
    line-height: 1.2;
    margin-bottom: 20px;
  }
  .box-count-value {
    text-align: right;
    /*font-weight: bold;*/
    font-size: 20px;
  }
  .box-header-filter {
    /*text-align: right;*/
    /*font-weight: bold;*/
    /*font-size: 10px !important;*/
    /*color: rgb(141, 141, 141) !important;*/
  }
  .box-count-circle {
    display: inline-block;
    width: 16px;
    height: 16px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    border-radius: 25px;
    margin-right: 10px;
    /*background: red;*/
  }
  .ivu-menu {
    z-index: 1;
  }
  .menu-item {
    font-size: 16px;
    line-height: 30px !important;
    padding: 0 5px !important;
    float: right;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    /*color: #2d8cf0;*/
    /*border-bottom: None;*/
    /*font-weight: bold;*/
    color: rgba(37, 215, 126, 1);
    border-bottom: unset;
  }
  .ivu-menu-horizontal.ivu-menu-light::after {
    background: white;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
    border-bottom: unset;
    /*color: #515a6e;*/
  }
  .ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-horizontal .ivu-menu-submenu {
    color: #8080809e;
    /*float: left;*/
    /*padding: 0 10px;*/
    /*position: relative;*/
    /*cursor: pointer;*/
    /*z-index: 3;*/
    /*transition: all 0.2s ease-in-out;*/
  }


  @media screen and (max-width: 1900px) {
    .menu-item {
      font-size: 15px;
    }
  }
  @media screen and (max-width: 1500px) {
    .menu-item {
      font-size: 14px;
    }
  }


  @media screen and (max-width: 991px) {
    h2 {
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/home/revenueBar.vue